"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: testapi/crypto-testapi-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftestapi%2Fcrypto-testapi-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoTestApiServiceClient = exports.SimulateIssueRewardResponse = exports.SimulateIssueRewardRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const offer_1 = require("../common/offer");
const crypto_1 = require("../crypto/crypto");
const crypto_testing_service_1 = require("../crypto/testing/crypto-testing-service");
const protobufPackage = 'com.step.testapi.proto';
function createBaseSimulateIssueRewardRequest() {
    return {
        userId: '',
        referenceId: '',
        offerId: '',
        paymentId: '',
        offer: offer_1.Offer.fromPartial({}),
        quantity: undefined,
        total: undefined,
        isOneTimeReward: false,
    };
}
exports.SimulateIssueRewardRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            referenceId: isSet(object.referenceId) ? globalThis.String(object.referenceId) : '',
            offerId: isSet(object.offerId) ? globalThis.String(object.offerId) : '',
            offer: isSet(object.offer) ? offer_1.Offer.fromJSON(object.offer) : offer_1.Offer.fromPartial({}),
        };
        if (isSet(object.paymentId)) {
            message.paymentId = globalThis.String(object.paymentId);
        }
        if (isSet(object.quantity)) {
            message.quantity = crypto_1.Quantity.fromJSON(object.quantity);
        }
        if (isSet(object.total)) {
            message.total = crypto_1.Total.fromJSON(object.total);
        }
        if (isSet(object.isOneTimeReward)) {
            message.isOneTimeReward = globalThis.Boolean(object.isOneTimeReward);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        if (message.offerId !== '') {
            obj.offerId = message.offerId;
        }
        if (message.paymentId !== undefined && message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.offer !== undefined) {
            obj.offer = offer_1.Offer.toJSON(message.offer);
        }
        if (message.quantity !== undefined) {
            obj.quantity = crypto_1.Quantity.toJSON(message.quantity);
        }
        if (message.total !== undefined) {
            obj.total = crypto_1.Total.toJSON(message.total);
        }
        if (message.isOneTimeReward !== undefined && message.isOneTimeReward !== false) {
            obj.isOneTimeReward = message.isOneTimeReward;
        }
        return obj;
    },
    create(base) {
        return exports.SimulateIssueRewardRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateIssueRewardRequest();
        message.userId = object.userId ?? '';
        message.referenceId = object.referenceId ?? '';
        message.offerId = object.offerId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.offer = (object.offer !== undefined && object.offer !== null)
            ? offer_1.Offer.fromPartial(object.offer)
            : offer_1.Offer.fromPartial({});
        message.quantity = (object.quantity !== undefined && object.quantity !== null)
            ? crypto_1.Quantity.fromPartial(object.quantity)
            : undefined;
        message.total = (object.total !== undefined && object.total !== null)
            ? crypto_1.Total.fromPartial(object.total)
            : undefined;
        message.isOneTimeReward = object.isOneTimeReward ?? false;
        return message;
    },
};
function createBaseSimulateIssueRewardResponse() {
    return {};
}
exports.SimulateIssueRewardResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SimulateIssueRewardResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSimulateIssueRewardResponse();
        return message;
    },
};
/**
 * Crypto Test API Service
 */
class CryptoTestApiServiceClient {
    rpc;
    name = 'com.step.testapi.proto.CryptoTestApiService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/test';
    methods = [{
            name: 'GetExternalCryptoAccounts',
            requestType: crypto_testing_service_1.GetExternalAccountsRequest,
            responseType: crypto_testing_service_1.GetExternalAccountsResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SimulateIssueReward',
            requestType: exports.SimulateIssueRewardRequest,
            responseType: exports.SimulateIssueRewardResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SeedGraduationConsentEmails',
            requestType: crypto_testing_service_1.SeedGraduationConsentEmailsRequest,
            responseType: crypto_testing_service_1.SeedGraduationConsentEmailsResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SyncUserWithAdmin',
            requestType: crypto_testing_service_1.SyncUserWithAdminRequest,
            responseType: crypto_testing_service_1.SyncUserWithAdminResponse,
            authenticationOptions: undefined,
        }, {
            name: 'Transfer',
            requestType: crypto_testing_service_1.TransferRequest,
            responseType: crypto_testing_service_1.TransferResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Gets list of external crypto accounts.
     */
    getExternalCryptoAccounts(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Simulates a crypto reward issuance
     */
    simulateIssueReward(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Seed graduation consent emails
     */
    seedGraduationConsentEmails(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Sync user data between Admin and local tables of crypto service,
     * can be used for tests until we get user feed in place.
     * For now, we sync only dob.
     */
    syncUserWithAdmin(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Transfer crypto asset from one account to another.
     */
    transfer(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.CryptoTestApiServiceClient = CryptoTestApiServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=crypto-testapi-service.js.map